import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {CircularProgress} from "@material-ui/core";
import {API_ROOT} from "../../../../../baseUrls";

const styles = {
  preview:{
    textAlign:'center',
    border: '1px solid rgba(0,0,0,0.27)',
    borderRadius: '4px',
    backgroundColor: 'rgba(0,0,0,0.050)',
    aspectRatio: 1,
    minHeight: '200px',
    minWidth: '200px',
    maxHeight: '350px',
    maxWidth: '350px',
    width: 'calc(min(100%,350px))',
    boxSizing: 'border-box'
  },
  previewLgIcon:{
    textAlign:'center',
    aspectRatio: 1,
    flexBasis:'300px',
    minWidth:'300px',
    height:'300px',
    width: 'calc(min(100%,350px))',
  },
  previewMd:{
    flexGrow:0,
    flexShrink:0,
    flexBasis:'225px',
    minWidth:'225px',
    height:'225px',
    textAlign:'center',
  },
  previewMdIcon:{
    flexGrow:0,
    flexShrink:0,
    flexBasis:'150px',
    minWidth:'150px',
    height:'100px',
    textAlign:'center',
  },
  previewSmIcon:{
    flexGrow:0,
    flexShrink:0,
    flexBasis:'72px',
    minWidth:'72px',
    height:'50px',
    textAlign:'center',
  },
  previewSm:{
    flexGrow:0,
    flexShrink:0,
    flexBasis:'40px',
    minWidth:'40px',
    height:'40px',
    textAlign:'center',
  },
  thumbnail: {
    display: 'inline-flex',
    boxSizing:'border-box',
    width: '100%',
    height: '100%',
    verticalAlign: 'text-bottom',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loader:{
    margin: 'auto',
    animationDuration: '4000ms',
    '& > svg > circle':{
      animationDuration: '4000ms',
    }
  },
  loaderSm:{
    margin: 'auto',
    animationDuration: '4000ms',
    '& > svg > circle':{
      animationDuration: '4000ms',
      strokeWidth:'0.25rem'
    }
  }
};

function UploadThumbnail(props) {
  const { id, item, ignoreConversion=false, thumbnailPath:userThumbnailPath, onClick, size, classes, thumbnailStyle, className } = props;
  const fileType = item.item_data_type !== "Upload" ? item.item_data_type : item.item_data.type;
  const thumbnailPath = userThumbnailPath || `${API_ROOT}/mindfiles/${item.mindfile_id}/show/${item.item_data_id}/${item.url_show_hash}/thumbnail?ts=${item.url_ts}`;
  const wrapperClass = size === "sm" ? classes.previewSm : size === "md" ? classes.previewMd : size === "mdic" ? classes.previewMdIcon : size === "smic" ? classes.previewSmIcon : size === "lgic" ? classes.previewLgIcon : classes.preview;
  const classNames = !!className ? `${className} ${wrapperClass}` : wrapperClass;

  const renderDefault = () => {
    return <div id={id} className={classNames} style={onClick ? {cursor: 'pointer', ...thumbnailStyle} : thumbnailStyle} onClick={onClick}>
      <div className={classes.thumbnail}
        style={
          fileType !== "audio" ?
            { background:`url(${thumbnailPath}) 50% 50%/contain no-repeat` }
            : { background: `url(${thumbnailPath}) no-repeat`, backgroundSize: "100% 100%" }
        }
      />
    </div>;
  };

  const renderConversion = () => {
    return <div id={id} className={classNames} style={onClick ? {cursor: 'pointer', ...thumbnailStyle} : thumbnailStyle} onClick={onClick}>
        <div className={classes.thumbnail}
         style={
           fileType !== "audio" ?
             { background:`url(${thumbnailPath}) 50% 50%/contain no-repeat` }
             : { background: `url(${thumbnailPath}) no-repeat`, backgroundSize: "100% 100%" }
         }
        >
          {item.item_data.conversion !== false ? null :
            <CircularProgress
              style={size === "sm" || size === "smic" ? {width:'28px', height: '28px', opacity:0.85} : size === "md" || size === "mdic" ? {width:'56px', height: '56px', opacity:0.85} : {width:'72px', height: '72px', opacity:0.85}}
              color="secondary"
              className={size === "sm" ? classes.loaderSm : classes.loader}
              variant="indeterminate"
            />
          }
        </div>
      </div>;
  };

  if(!ignoreConversion && item.item_data.conversion !== true){
    return renderConversion();
  }
  return renderDefault();
}

export default withStyles(styles)(UploadThumbnail);
